import {DateTime} from 'luxon';


const KEY_META = '_meta';


/**
 * @return {object} Default meta state
 */
export const getDefaultMetaState = () => {

    return {
        isLoaded: false,
        isLoading: false,
        isUpdating: false,
        loadTime: null
    };
};


/**
 * @param state {object} State to enrich with meta state
 * @return {object} Enriched meta state
 */
export const withDefaultMetaState = state => {

    state[KEY_META] = getDefaultMetaState();

    return state;
};


/**
 * @param state {object} State to get meta state from
 * @return {object} Existing meta state or default meta state
 */
const getMetaState = state => {

    return state[KEY_META] || getDefaultMetaState();
};


/**
 * @param state {object} State to get meta state from and set in
 * @param prop {string} Prop name
 * @param value {any} Meta state prop value
 * @return {object} Updated state
 */
const setMetaStateValue = (state, prop, value) => {

    const metaState = getMetaState(state);
    metaState[prop] = value;
    state[KEY_META] = metaState;

    return state;
};


/**
 * @param {object} state State with meta information
 * @returns {Boolean} True if loaded; false if not
 */
export const isLoaded = state => {

    return getMetaState(state)
        .isLoaded;
};


/**
 * @param {object} state State with meta information
 * @returns {Boolean} True if loading; false if not
 */
export const isLoading = state => {

    return getMetaState(state).isLoading;
};


/**
 * @param {object} state State with meta information
 * @returns {Boolean} True if loading; false if not
 */
export const isUpdating = state => {

    return getMetaState(state).isUpdating;
};


/**
 * @param {object} state State with meta information
 * @returns {Boolean} True if neither loading nor loaded; false if any of those is active
 */
export const isMissing = state => {

    return !isLoading(state) && !isLoaded(state);
};


/**
 * @param {object} state State with meta information
 * @returns {object} State in loading state
 */
export const setIsLoading = state => {

    return setMetaStateValue(state, 'isLoading', true);
};

/**
 * @param {object} state State with meta information
 * @returns {object} State in loading state
 */
export const setIsUpdating = state => {

    return setMetaStateValue(state, 'isUpdating', true);
};


/**
 * @param {object} state State with meta information
 * @returns {object} State in loaded state
 */
export const setIsLoaded = state => {

    state[KEY_META] = {
        isLoading: false,
        isLoaded: true,
        isUpdating: false,
        loadTime: DateTime.utc()
    };

    return state;
};
